
import { BaseBus } from "./BaseBus";
export class StockReplenishmentsBus {

    branches: StockReplenishmentBus[];
    persons: StockReplenishmentBus[];

}

export class StockReplenishmentBus extends BaseBus
{
    constructor(data: StockReplenishmentBus) {
        super(data);
    }

    CID(): any {
        return this.id;
    }
    initialize(data: StockReplenishmentBus) {
        super.initialize(data);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: StockReplenishmentBus) {
        super.setFromForm(data);
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
    }

    id: string;
    name: string;
    onStockReplenishment: boolean;
}
